<template>
  <div>
    <v-dialog v-model="value" max-width="80%" persistent scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex md4>
                &nbsp;
            </v-flex>
            <v-flex xs12 sm4 md4 lg4 xl4>
              <v-flex class="titleSearch">
                <v-text-field
                  @input="filterSearch"
                  label="Buscar"
                  prepend-inner-icon="search"
                  solo-inverted
                  clearable
                />
              </v-flex>
            </v-flex>
            <v-flex md4>
                  &nbsp;
            </v-flex>
          </v-layout>
          <!-- table -->
          <v-layout row wrap>
            <v-data-table
              style="width: 100%"
              :headers="headers"
              :items="notice.students"
              :custom-filter="customFilter"
              no-data-text="No hay alumnos"
              :search="filters"
              no-results-text="No se encontraron coincidencias"
              :rows-per-page-items="[10, 15, 25]"
              rows-per-page-text="Registros por página"
          >
            <template v-slot:headers="props">
              <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
            </template>

            <template
              v-slot:pageText="props"
            >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.firstName + " "+ props.item.lastName }}</td>
              <td
                class="text-xs-center"
              >{{ props.item.noticeConfirmParent ? props.item.noticeConfirmParent.firstName +" " + props.item.noticeConfirmParent.lastName : "" }}</td>
              <td class="text-xs-center">
                <!-- <v-chip
                  :color="props.item.noticeConfirm == 'P' ? 'yellow' : props.item.noticeConfirm == 'A' ? 'green' : 'red'"
                >
                  <v-avatar
                    color="grey lighten-4"
                    v-if="props.item.noticeConfirmParent && props.item.noticeConfirmParent.image && props.item.noticeConfirmParent.image != '' && props.item.noticeConfirmParent.image != ' '  && props.item.noticeConfirmParent.image != 'data:image/jpeg;base64,undefined'"
                  >
                    <img
                      :src="'data:image/jpeg;base64,'+props.item.noticeConfirmParent.image"
                      alt="avatar"
                    />
                  </v-avatar>
                 
                  {{ props.item.noticeConfirm == "P" ? "Pendiente" : props.item.noticeConfirm == "A" ? "Autorizado" : "Cancelado" }}
                </v-chip> -->
                  <span v-bind:style="props.item.noticeConfirm == 'P' ? 'color:orange' : props.item.noticeConfirm == 'A' ? 'color:green' : 'red'">
                  {{ props.item.noticeConfirm == "P" ? "Pendiente" : props.item.noticeConfirm == "A" ? "Confirmado" : "Cancelado" }}
                  </span>
              </td>
              <td class="text-xs-center" >
                <b  v-if="props.item.noticeConfirmDate" > {{ props.item.noticeConfirmDate | formatDate }}</b>
                <b  v-else> ----- </b>
              </td>
            </template>
          </v-data-table>
          </v-layout>

          
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="close">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["title", "notice", "value"],
  components: {},
  watch: {},
  mounted() {},
  data: () => ({
    modals: {
      image: false
    },
    avatarSize: "30px",
    tile: false,
    filters: {
      search: ""
    },

    userImg: null,
    working: {
      wUpdate: false,
      wImage: false
    },
    headers: [
      {
        text: "Alumno",
        align: "center",
        value: "firstName"
      },
      { text: "Tutor", align: "center", value: "tutor" },
      { text: "Estado", align: "center", value: "noticeConfirm" },
      { text: "Fecha y hora de confirmación", align: "center", value: "time" }
    ]
  }),
  methods: {
    submit() {},
    close() {
      this.userForm = {};
      this.$emit("input", !this.value);
    },
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers);

      cf.registerFilter("search", function(searchWord, items) {
        if (searchWord == null) return items;

        return items.filter(item => {
          return (
            (item.noticeConfirmParent &&
              item.noticeConfirmParent.firstName
                .toLowerCase()
                .includes(searchWord.toLowerCase())) ||
            (item.noticeConfirmParent &&
              item.noticeConfirmParent.lastName
                .toLowerCase()
                .includes(searchWord.toLowerCase())) ||
            item.lastName
              .toLowerCase()
              .toLowerCase()
              .includes(searchWord.toLowerCase()) ||
            item.firstName
              .toLowerCase()
              .toLowerCase()
              .includes(searchWord.toLowerCase())
          );
        }, searchWord);
      });
      return cf.runFilters();
    },
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val
      });
    }
  },
  computed: {}
};
</script>

<style>
.titleSearch .v-input .v-text-field .v-input__slot {
  border-radius: 33px !important;
}
</style>
<style scoped>
td,
th {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
}
</style>